import React, { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const [atTop, setAtTop] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Resize listener
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll listener
  useEffect(() => {
    const toggleVisibility = () => {
      const yOffset = window.pageYOffset;
      setVisible(yOffset > 300);
      setAtTop(yOffset <= 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const handleClick = () => {
    window.scrollTo({
      top: atTop ? document.body.scrollHeight : 0,
      behavior: "smooth",
    });
  };

  // ✅ styles INSIDE component
  const styles = {
    button: {
      position: "fixed",
      bottom: isMobile ? "71px" : "100px",
      right: isMobile ? "17px" : "32px",
      backgroundColor: "white",
      border: "none",
      padding: isMobile ? "4px" : "10px",
      fontSize: isMobile ? "20px" : "24px",
      fontWeight: "bold",
      cursor: "pointer",
      borderRadius: "50%",
      outline: "none",
      zIndex: 1000,
      transition: "opacity 0.3s ease",
    },
  };

  return (
    <>
      {visible && (
        <button onClick={handleClick} style={styles.button}>
          <img
            width="35"
            height="35"
            src={
              atTop
                ? "https://img.icons8.com/color/48/chevron-down.png"
                : "https://img.icons8.com/color/48/chevron-up.png"
            }
            alt="scroll"
          />
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
